import React, {useEffect} from 'react';
import {useLanguage} from '../../utils/LanguageContext';

const Translator = () => {
  const {updateLanguage} = useLanguage();

  useEffect(() => {
    const trackLanguageChanges = () => {
      const select = document.querySelector('.goog-te-combo');

      if (select) {
        select.addEventListener('change', event => {
          const selectedLang = event.target.value;
          updateLanguage(selectedLang);
        });
      }
      else {
        // Keep trying to find the select element
        setTimeout(trackLanguageChanges, 1000);
      }
    };

    // Start tracking after Google Translate has had time to initialize
    setTimeout(trackLanguageChanges, 3000);
  }, [updateLanguage]);

  // Just return the element - let the HTML script handle everything
  return <div id='google_translate_element'/>;
};

export default Translator;
